import { render, staticRenderFns } from "./selectGoodsSku.vue?vue&type=template&id=4bfda747&scoped=true"
import script from "./selectGoodsSku.vue?vue&type=script&lang=js"
export * from "./selectGoodsSku.vue?vue&type=script&lang=js"
import style0 from "./selectGoodsSku.vue?vue&type=style&index=0&id=4bfda747&prod&lang=scss&scoped=true"
import style1 from "./selectGoodsSku.vue?vue&type=style&index=1&id=4bfda747&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfda747",
  null
  
)

export default component.exports